import ProxyBase from '../../../../../core/proxies/ProxyBase'

class FinancialAnalysisProxy extends ProxyBase {
  getTemplates(params) {
    return this.get('Templates', params, undefined, true)
  }

  getTemplateDetail(params) {
    return this.get('TemplateDetail', params)
  }

  setDefaultTemplate(params) {
    return this.post('SetDefaultTemplate', params)
  }

  deleteTemplates(params) {
    return this.delete('DeleteTemplate', params)
  }

  updateTemplate(params) {
    return this.post('UpdateTemplate', params)
  }

  saveTemplate(params) {
    return this.post('SaveTemplate', params)
  }

  getDefaultTemplate(params) {
    return this.get('DefaultTemplate', params, undefined, true)
  }

  getHighlight(params) {
    return this.post('Highlight', params)
  }

  getProfitability(params) {
    return this.post('Profitability', params)
  }

  downloadProfitability(params) {
    return this.post('Profitability/export', params, {}, 'download')
  }

  getQuickAssessmentCorporate(params) {
    return this.post('QuickAssessment/corp', params)
  }

  downloadQuickAssessmentCorporate(params) {
    return this.post('QuickAssessment/corp/export', params, {}, 'download')
  }

  getRoaAndRoe(params) {
    return this.post('RoaAndRoe', params)
  }

  downloadRoaAndRoe(params) {
    return this.post('RoaAndRoe/export', params, {}, 'download')
  }

  getAssetManagementEfficiency(params) {
    return this.post('AssetManagementEfficiency', params)
  }

  downloadAssetManagementEfficiency(params) {
    return this.post('AssetManagementEfficiency/export', params, {}, 'download')
  }

  getCoverage(params) {
    return this.post('Coverage', params)
  }

  downloadCoverage(params) {
    return this.post('Coverage/export', params, {}, 'download')
  }

  getSolvency(params) {
    return this.post('Solvency', params)
  }

  downloadSolvency(params) {
    return this.post('Solvency/export', params, {}, 'download')
  }

  getBankQuickAssessment(params) {
    return this.post('QuickAssessment/bank', params)
  }

  downloadBankQuickAssessment(params) {
    return this.post('QuickAssessment/bank/export', params, {}, 'download')
  }

  getNonBankQuickAssessment(params) {
    return this.post('QuickAssessment/nonbank', params)
  }

  downloadNonBankQuickAssessment(params) {
    return this.post('QuickAssessment/nonbank/export', params, {}, 'download')
  }

  getLoanBookBreakdown(params) {
    return this.post('LoanBookBreakdownAndCoverage', params)
  }

  downloadLoanBookBreakdown(params) {
    return this.post(
      'LoanBookBreakdownAndCoverage/export',
      params,
      {},
      'download',
    )
  }

  getDepositAndCredit(params) {
    return this.post('DepositAndCredit', params)
  }

  downloadDepositAndCredit(params) {
    return this.post('DepositAndCredit/export', params, {}, 'download')
  }

  getAverageCost(params) {
    return this.post('AverageCostOfFinancingAndCreditCost', params)
  }

  downloadAverageCost(params) {
    return this.post(
      'AverageCostOfFinancingAndCreditCost/export',
      params,
      {},
      'download',
    )
  }

  getCapitalAndLeverage(params) {
    return this.post('CapitalAndLeverage', params)
  }

  downloadCapitalAndLeverage(params) {
    return this.post('CapitalAndLeverage/export', params, {}, 'download')
  }

  getLiquidity(params) {
    return this.post('Liquidity', params)
  }

  downloadLiquidity(params) {
    return this.post('Liquidity/export', params, {}, 'download')
  }

  getFundingStructure(params) {
    return this.post('Funding', params)
  }

  downloadFundingStructure(params) {
    return this.post('Funding/export', params, {}, 'download')
  }

  getEarningBreakdown(params) {
    return this.post('EarningsBreakdown', params)
  }

  downloadEarningBreakdown(params) {
    return this.post('EarningsBreakdown/export', params, {}, 'download')
  }

  getBalanceBreakdown(params) {
    return this.post('BalanceSheetBreakdown', params)
  }

  downloadBalanceBreakdown(params) {
    return this.post('BalanceSheetBreakdown/export', params, {}, 'download')
  }

  getCashBreakdown(params) {
    return this.post('CashFlowBreakdown', params)
  }

  downloadCashBreakdown(params) {
    return this.post('CashFlowBreakdown/export', params, {}, 'download')
  }

  getOperatingIncome(params) {
    return this.post('OperatingIncome', params)
  }

  downloadOperatingIncome(params) {
    return this.post('OperatingIncome/export', params, {}, 'download')
  }

  getBusinessPosition(params) {
    return this.post('BusinessPosition', params)
  }

  downloadBusinessPosition(params) {
    return this.post('BusinessPosition/export', params, {}, 'download')
  }

  getFinancialAssets(params) {
    return this.post('FinancialAssets', params)
  }

  downloadFinancialAssets(params) {
    return this.post('FinancialAssets/export', params, {}, 'download')
  }

  getEarningsQuality(params) {
    return this.post('EarningsQuality', params)
  }

  downloadEarningsQuality(params) {
    return this.post('EarningsQuality/export', params, {}, 'download')
  }

  getLeverage(params) {
    return this.post('Leverage', params)
  }

  downloadLeverage(params) {
    return this.post('Leverage/export', params, {}, 'download')
  }

  getFundingAndLiquidity(params) {
    return this.post('FundingAndLiquidity', params)
  }

  downloadFundingAndLiquidity(params) {
    return this.post('FundingAndLiquidity/export', params, {}, 'download')
  }

  getInsurancePremiumRevenue(params) {
    return this.post('InsurancePremiumRevenue', params)
  }

  downloadInsurancePremiumRevenue(params) {
    return this.post('InsurancePremiumRevenue/export', params, {}, 'download')
  }

  getInsuranceSolvency(params) {
    return this.post('InsuranceSolvency', params)
  }

  downloadInsuranceSolvency(params) {
    return this.post('InsuranceSolvency/export', params, {}, 'download')
  }

  getOperationalEfficiency(params) {
    return this.post('OperationalEfficiency', params)
  }

  downloadOperationalEfficiency(params) {
    return this.post('OperationalEfficiency/export', params, {}, 'download')
  }

  getIndicatorPanel(params) {
    return this.get('Preferences/Indicators', params)
  }
}

export default new FinancialAnalysisProxy('FinancialAnalysis/')
